import { format, parseISO } from 'date-fns'
import $api2 from '@/plugins/axiosInstance2.js'
import $api from '@/plugins/axiosInstance.js'
import CONST from '@/const.js'
import isEmpty from 'lodash/isEmpty'


const state = {
  
}
const mutations = {
  
}

const actions = {
    
    LIST_FAQ: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: '/admin/faq', params: payload}).then((result) => {
            return result.data
        })
        }
    },
    DETAIL_FAQ: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: '/admin/faq/' + payload.id, params: payload}).then((result) => {
            return result.data
        })
        }
    },
    UPDATE_FAQ: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'put', url: '/admin/faq/' + payload.id, data: payload}).then((result) => {
            return result.data
        })
        }
    },
    POST_FAQ: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'post', url: '/admin/faq', data  : payload}).then((result) => {
            return result.data
        })
        }
    },
    LIST_NOTICE: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: '/announcement', params: payload}).then((result) => {
            return result.data
        })
        }
    },
    DETAIL_NOTICE: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: '/announcement/' + payload.id, params: payload}).then((result) => {
            return result.data
        })
        }
    },
    UPDATE_NOTICE: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'put', url: '/announcement/' + payload.id, data: payload}).then((result) => {
            return result.data
        })
        }
    },
    POST_NOTICE: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'post', url: '/announcement', data  : payload}).then((result) => {
            return result.data
        })
        }
    },
    
    LIST_TICKET: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: '/admin/ticket', params: payload}).then((result) => {
            return result.data
        })}
    },
    DETAIL_TICKET: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: '/admin/ticket/' + payload.id, params: payload}).then((result) => {
            return result.data
        })
        }
    },
    POST_TICKET_MESSAGE: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'post', url: '/admin/ticket/' + payload.id + '/messages', data  : payload}).then((result) => {
            return result.data
        })
        }
    },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  //getters: getters,
}
